import { render } from "./createUsersComponent.vue?vue&type=template&id=9405a482&scoped=true"
import script from "./createUsersComponent.vue?vue&type=script&lang=js"
export * from "./createUsersComponent.vue?vue&type=script&lang=js"

import "./createUsersComponent.vue?vue&type=style&index=0&id=9405a482&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9405a482"]])

export default __exports__